import { z } from "../wire/zod";

export const noDataSchema = z.record(z.string(), z.never());
export const sendMessageResponseSchema = z.object({
  conversationId: z
    .string()
    .describe(
      "Id of the persisted conversation; absent on degraded answers that carry no conversation",
    )
    .optional(),
  blocks: z.array(
    z.union([
      z.object({ type: z.literal("text"), text: z.string() }),
      z.object({
        type: z.literal("table"),
        columns: z.array(z.string()).describe("Display-ready column headers"),
        rows: z.array(
          z.array(
            z.union([
              z.object({
                kind: z.literal("sticky"),
                id: z.string(),
                label: z.string(),
                typeId: z.string(),
                boardId: z.string(),
              }),
              z.object({
                kind: z.literal("objective"),
                id: z.string(),
                label: z.string(),
                boardId: z.string(),
                level: z.enum(["team", "art"]),
                stretch: z.boolean().describe("Uncommitted (stretch) objective"),
                bv: z.number().int().describe("Business value"),
              }),
              z.object({
                kind: z.literal("team"),
                id: z.string(),
                label: z.string().describe("Display name at answer time"),
              }),
              z.object({
                kind: z.literal("user"),
                id: z.string(),
                label: z
                  .string()
                  .describe("Display name at answer time, or Unknown User when unresolved"),
              }),
              z.object({
                kind: z.literal("board"),
                id: z.string(),
                label: z.string().describe("Display name at answer time"),
              }),
              z.object({
                kind: z.literal("art"),
                id: z.string(),
                label: z.string().describe("Display name at answer time"),
              }),
              z.object({
                kind: z.literal("text"),
                text: z.string().describe("Server-resolved display string"),
              }),
              z.object({ kind: z.literal("number"), value: z.number() }),
            ]),
          ),
        ),
      }),
      z.object({
        type: z.literal("chart"),
        kind: z.enum(["pie", "bar"]),
        categories: z.array(z.string()).describe("Slice / axis labels, display-ready"),
        series: z.array(
          z.object({
            name: z
              .string()
              .describe("Legend label, needed once there is more than one series")
              .optional(),
            values: z.array(z.number()).describe("One value per category, aligned by index"),
          }),
        ),
      }),
    ]),
  ),
});
